<template>
  <GmapMap
    :center="center"
    :zoom="zoom"
    map-type-id="terrain"
    style="height: 100%"
    ref="polemap"
  >
    <gmap-info-window
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false"
    >
      <div v-html="infoContent"></div>
    </gmap-info-window>
    <GmapPolygon
      v-for="land in lands"
      :path="land.coordinates"
      :options="land.options"
      v-on:click="showLandDetails(land, $event.latLng)"
    >
    </GmapPolygon>
  </GmapMap>
</template>

<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
 
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_KEY
    //key: 'AIzaSyD_qgmf_vBTn1I-_ixa5uyET5YPBjzB0Tg',
    //key: 'AIzaSyDRe7B4lik6DuUYTadnCpeCU-HcRhkuUBc', //dev
  },
})

export default {
  data() {
    return {
      zoom: 6,
      lands: [],
      center: {lat:49, lng:32},
      displayedZone: {
        min: {
          lat: 999,
          lng: 999
        },
        max: {
          lat: 0,
          lng: 0
        },
      },
      infoWinOpen: false,
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
    }
  },
  mounted() { // todo - how to solve -should wait before map loaded|init?
    this.loadLands()
  },
  computed: {
      distictChangedListener() {
        return this.$store.getters.getCurrentDistrict
      }
  },
  watch: {
    distictChangedListener: function (value) {
      this.loadLands()
    }
  },
  methods: {
    loadLands() {
      if (!this.$store.getters.getCurrentDistrict) {
        return;
      }

      this.$store.commit('startLoading')

      this.$http.get('lands/' + this.$store.getters.getCurrentDistrict)
        .then(response => {
          return response.json()
        })
        .then(lands => {
          if (lands.length == 0) {
            this.$store.commit('stopLoading')
            this.$store.commit('showAlert', 'Земельні ділянки для даного району не знайдено');
            return;
          }

          var self = this
          self.lands = []

          lands.forEach(function(el) {
            let land = {
              options: {
                fillColor: "orange",
                fillOpacity: 0.35,
                strokeWeight: 1,
                strokeOpacity: 0.8,
                strokeColor: '#004e72',
              },
              data: {
                area: el.area,
                phone: el.phone,
                kadastr: el.kadastr
              },
              coordinates: []
            }

            el.geometry.forEach(function(point) {
              land.coordinates.push({lat: point[0], lng: point[1]})
              self.saveExtremePoints(point[0], point[1])
            })

            self.lands.push(land)
          })

          self.$store.commit('stopLoading')
          self.boundToDisplayedZone()
        })
    },
    showLandDetails(land, coordinates) {
      this.infoWindowPos.lng = coordinates.lng()
      this.infoWindowPos.lat = coordinates.lat()
      this.infoContent = 'Кадастровий номер: <strong>' + land.data.kadastr + '</strong>' +
                         '<br>Площа: <strong>' + land.data.area + ' га</strong>' +
                         '<br>Телефон: <strong>' + land.data.phone + '</strong>'
      this.infoWinOpen = true
    },
    saveExtremePoints(lat, lng) {
      if (this.displayedZone.max.lng < lng) {
        this.displayedZone.max.lng = lng
      }
      if (this.displayedZone.max.lat < lat) {
        this.displayedZone.max.lat = lat
      }
      if (this.displayedZone.min.lat > lat) {
        this.displayedZone.min.lat = lat
      }
      if (this.displayedZone.min.lng > lng) {
        this.displayedZone.min.lng = lng
      }
    },
    boundToDisplayedZone() {
      this.$refs.polemap.fitBounds(
        new google.maps.LatLngBounds(
          new google.maps.LatLng(this.displayedZone.min.lat, this.displayedZone.min.lng),
          new google.maps.LatLng(this.displayedZone.max.lat, this.displayedZone.max.lng)
        )
      )
    }
  }
}
</script>